/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateOfferProductSurfacesRequest } from '../../models/update-offer-product-surfaces-request';

export interface UpdateOfferProductSurfaces$Params {
  id: number;
  productId: number;
      body: UpdateOfferProductSurfacesRequest
}

export function updateOfferProductSurfaces(http: HttpClient, rootUrl: string, params: UpdateOfferProductSurfaces$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateOfferProductSurfaces.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('productId', params.productId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateOfferProductSurfaces.PATH = '/offers/{id}/product-articles/{productId}';
